// 主色为 #2e3968
const chartColors = [
    '#2e3968', // 深蓝 - 主色
    '#005f73', // 深青蓝
    '#0a9396', // 青绿
    '#94d2bd', // 浅蓝绿
    '#e9d8a6', // 柔黄
    '#ee9b00', // 明橘
    '#ca6702', // 橙棕
    '#bb3e03', // 深橘红
    '#780000', // 酒红（新增）
    '#c1121f', // 正红（新增）
    '#fdf0d5', // 米白（新增）
    '#669bbc'  // 天蓝（新增）
  ];
  
  export default chartColors;
  